var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.forum !== null)?_c('router-view',{attrs:{"forumProp":_vm.forum,"communityID":_vm.communityID,"communityOwner":_vm.communityOwner,"communityName":_vm.communityName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }